export enum AnalyticsTimeframesEnum {
    TODAY,
    LAST_WEEK,
    LAST_MONTH,
    LAST_YEAR,
    FIXED_TIMEFRAME,
}